import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
//
import Header from './header';
import Nav from './nav';
import MobileBottomNav, { MOBILE_BOTTOM_NAV_HEIGHT } from './mobile/MobileBottomNav';
import MobileMoreSheet from './mobile/MobileMoreSheet';
import { WhatsappUnreadProvider } from '../../contexts/WhatsappUnreadContext';
import ActingHubBanner from '../../components/super-admin/ActingHubBanner';

// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 92;

const StyledRoot = styled('div')({
  display: 'flex',
  // dvh tracks the shrinking/growing mobile browser chrome; vh does not.
  height: '100dvh',
  minHeight: '100vh',
  overflow: 'hidden',
});

const Main = styled('div')(({ theme }) => ({
  flexGrow: 1,
  width: '100%',
  minWidth: 0,
  height: '100dvh',
  overflowY: 'auto',
  overflowX: 'hidden',
  WebkitOverflowScrolling: 'touch',
  paddingTop: APP_BAR_MOBILE + 16,
  // Room for the fixed bottom tab bar + iOS home indicator.
  paddingBottom: `calc(${theme.spacing(2)} + ${MOBILE_BOTTOM_NAV_HEIGHT}px + env(safe-area-inset-bottom))`,
  paddingLeft: theme.spacing(1),
  paddingRight: theme.spacing(1),
  [theme.breakpoints.up('sm')]: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  [theme.breakpoints.up('lg')]: {
    paddingTop: APP_BAR_DESKTOP + 24,
    paddingBottom: theme.spacing(10),
  },
}));

// ----------------------------------------------------------------------

export default function DashboardLayout() {
  const { pathname } = useLocation();
  const [openNavDesktop, setOpenNavDesktop] = useState(true);
  const [openMore, setOpenMore] = useState(false);

  // Always dismiss More on navigation so its modal backdrop cannot linger.
  useEffect(() => {
    setOpenMore(false);
    // Only touch body scroll-lock styles — never remove React-owned DOM nodes.
    document.body.style.removeProperty('overflow');
    document.body.style.removeProperty('padding-right');
  }, [pathname]);

  return (
    <WhatsappUnreadProvider>
    <StyledRoot>
      <Header
        onOpenNav={() => setOpenMore(true)}
        onToggleDesktopNav={() => setOpenNavDesktop((prev) => !prev)}
        isDesktopNavOpen={openNavDesktop}
      />

      {/* Desktop sidebar only — mobile uses the bottom bar + More sheet. */}
      <Nav isDesktopNavOpen={openNavDesktop} />

      <Main data-mobile-scroll-root="true">
        <ActingHubBanner />
        <Outlet />
      </Main>

      <MobileBottomNav onOpenMore={() => setOpenMore(true)} />
      {openMore ? <MobileMoreSheet open onClose={() => setOpenMore(false)} /> : null}
    </StyledRoot>
    </WhatsappUnreadProvider>
  );
}
